import React from "react";
import { Link } from "react-router-dom";
import { XCircleIcon, ArrowLeftIcon } from "@phosphor-icons/react";

export default function CheckoutCancel() {
  return (
    <div data-testid="checkout-cancel-page" className="min-h-screen bg-[#0B0C10] text-[#F1F5F9] flex items-center justify-center p-6">
      <div className="max-w-md w-full text-center">
        <XCircleIcon size={56} className="mx-auto text-[#94A3B8]" />
        <h1 className="text-3xl font-medium tracking-tight mt-6">Checkout cancelled</h1>
        <p className="text-sm text-[#94A3B8] mt-3">No charge was made. Your card and email were never billed.</p>
        <Link to="/store" data-testid="cancel-return"
              className="mt-8 inline-flex items-center gap-2 px-6 py-3 rounded-md bg-[#D6FF38] text-black mono uppercase tracking-widest text-xs">
          <ArrowLeftIcon size={12} /> Back to store
        </Link>
      </div>
    </div>
  );
}
